import { IonPage } from '@ionic/react';
import styled from 'styled-components';

export const PaywallV5Styles = styled(IonPage)<{
  hasTimer: boolean;
}>`
  ion-content {
    --background: #000;
    --padding-top: 72px;
    z-index: 0;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url(/assets/layout-own-ai-dominate/welcome/glowing-overlay.png)
        no-repeat center center / cover;
      z-index: 1;
      pointer-events: none;
    }

    &::part(scroll) {
      margin: 0;
      padding: 0;
      z-index: 2;

      ${({ hasTimer }) => hasTimer && `margin-top: 72px;`}
    }
  }
`;
